import { Expose } from "class-transformer";
import { IsEmail, IsEnum, IsNotEmpty } from "class-validator";

export enum PackageName {
  BACKYARD = "back-yard",
  FRONT_YARD = "front-yard",
  FULL_YARD = "full-yard",
  PREMIUM = "premium",
  CURB_APPEAL = "curb-appeal",
  OUTDOOR_TRANSFORMATION = "outdoor-transformation",
  BOTANICAL = "botanical",
  OUTDOOR_LIVING_SPACE = "outdoor-living-space-design",

  // Good Better Best
  GOOD_BETTER_BEST_AREA = "area-options",
  GOOD_BETTER_BEST_BACK_YARD = "backyard-options",
  GOOD_BETTER_BEST_FULL_YARD = "full-yard-options",
  GOOD_BETTER_BEST_PREMIUM = "premium-options",
}

export class PackageRecommendationOutput {
  @Expose()
  @IsEnum(PackageName)
  @IsNotEmpty()
  packageName: PackageName;

  @Expose()
  @IsEmail()
  @IsNotEmpty()
  clientEmail: string;
}
